export const wallets = {
  WALLETS_HEADING: "المعاملات المالية الخاصة بك",
  PAYMENT_CUSTOMER_PAY_BUYER: "  تم دفع قيمه المعامله الى  ",
  PAYMENT_CUSTOMER_PAY_BUYER_SUB: "المبلغ محجوز لحين انتهاء المعامله ",
  SAR: " ريال ",
  PAYMENT_CUSTOMER_REFUND: "تم ايداع ",
  PAYMENT_CUSTOMER_REFUND_TEXT: " الى حساب",
  PAYMENT_RELASE_BUYER: " تم ارجاع قيمه المعامله لحسابك",
  PAYMENT_RELASE_BUYER_SUB: " قمنا برد المبلغ لحساب المشترى   ",
  PAYMENT_SELLER_CUSTOMER_PAY_BUYER: " تم دفع قيمه المعامله بواسطه  ",
  SELLER_PAYMENT_CUSTOMER_REFUND: "تم ايداع ",
  SELLER_PAYMENT_CUSTOMER_REFUND_TEXT: " فى حسابك البنكي",
  SELLER_PAYMENT_RELASE_BUYER: " تم ارجاع قيمه المعامله لحساب",
  SELLER_PAYMENT_RELASE_BUYER_SUB: " قمنا برد المبلغ لحساب المشترى   ",
  ALL_TRANS: "  كل المعاملات ",
  BALANCE: "رصيد وفى",
};

export const BUYER = "buyer";
export const SELLER = "SELLER";
